module.exports = __webpack_public_path__ + "img/op_home-personas-2.114259e.jpg";